import LeadsService from '@/services/api/leads.services'

const state = {
    leads: [],
    leadsData: {
        leads: [],
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 1,
    },
    statuses: [],
    sources: [],
    currentLead: null,
    isLoading: false,
}

const mutations = {
    SET_LEADS(state, payload) {
        state.leads = payload
    },
    SET_LEADS_DATA(state, payload) {
        state.leadsData = {
            leads: payload.leads || [],
            total: payload.total || 0,
            per_page: payload.per_page || 20,
            current_page: payload.current_page || 1,
            last_page: payload.last_page || 1,
        }
    },
    SET_STATUSES(state, payload) {
        state.statuses = payload
    },
    SET_SOURCES(state, payload) {
        state.sources = payload
    },
    SET_CURRENT_LEAD(state, payload) {
        state.currentLead = payload
    },
    SET_LOADING(state, payload) {
        state.isLoading = payload
    },
    UPDATE_LEAD_STATUS(state, { id, status_id }) {
        const lead = state.leadsData.leads.find((l) => l.id === id)
        if (lead) {
            lead.status_id = status_id
        }
    },
}

const actions = {
    getLeads({ commit }, params = {}) {
        commit('SET_LOADING', true)
        return new Promise((resolve, reject) => {
            LeadsService.get('leads', '', params)
                .then((response) => {
                    const leads = response.data.data || []
                    const meta = response.data.meta || {}
                    commit('SET_LEADS_DATA', {
                        leads: leads,
                        total: meta.total || 0,
                        per_page: meta.per_page || 20,
                        current_page: meta.current_page || 1,
                        last_page: meta.last_page || 1,
                    })
                    commit('SET_LOADING', false)
                    return resolve(response)
                })
                .catch((error) => {
                    commit('SET_LOADING', false)
                    return reject(error)
                })
        })
    },

    getLead({ commit }, id) {
        return new Promise((resolve, reject) => {
            LeadsService.get('lead', id)
                .then((response) => {
                    commit('SET_CURRENT_LEAD', response.data.data)
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    createLead(context, payload) {
        return new Promise((resolve, reject) => {
            LeadsService.post('leads', {}, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    updateLead(context, { id, ...payload }) {
        return new Promise((resolve, reject) => {
            LeadsService.put('lead', id, payload)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    updateLeadStatus({ commit }, { id, status_id }) {
        return new Promise((resolve, reject) => {
            LeadsService.patch('leadStatus', id, { status_id })
                .then((response) => {
                    commit('UPDATE_LEAD_STATUS', { id, status_id })
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    deleteLead(context, id) {
        return new Promise((resolve, reject) => {
            LeadsService.delete('lead', id)
                .then((response) => {
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getStatuses({ commit }) {
        return new Promise((resolve, reject) => {
            LeadsService.get('statuses')
                .then((response) => {
                    commit('SET_STATUSES', response.data.data || [])
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },

    getSources({ commit }) {
        return new Promise((resolve, reject) => {
            LeadsService.get('sources')
                .then((response) => {
                    commit('SET_SOURCES', response.data.data || [])
                    return resolve(response)
                })
                .catch((error) => reject(error))
        })
    },
}

const getters = {
    getLeads: (state) => state.leadsData.leads,
    getLeadsData: (state) => state.leadsData,
    getStatuses: (state) => state.statuses,
    getSources: (state) => state.sources,
    getCurrentLead: (state) => state.currentLead,
    isLoading: (state) => state.isLoading,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}

